import { FC } from 'react';

const CalendarIcon: FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M20.9061 4.5H18.8749V5.74998H20.7499V19.4998H3.25014V5.74998H5.12511V4.5H3.09389C2.94779 4.50244 2.80361 4.53364 2.66957 4.59182C2.53553 4.64999 2.41426 4.734 2.31269 4.83905C2.21113 4.9441 2.13125 5.06813 2.07763 5.20405C2.024 5.33998 1.99768 5.48513 2.00016 5.63123V19.6185C1.99768 19.7646 2.024 19.9098 2.07763 20.0457C2.13125 20.1816 2.21113 20.3056 2.31269 20.4107C2.41426 20.5157 2.53553 20.5997 2.66957 20.6579C2.80361 20.7161 2.94779 20.7473 3.09389 20.7497H20.9061C21.0522 20.7473 21.1964 20.7161 21.3304 20.6579C21.4645 20.5997 21.5857 20.5157 21.6873 20.4107C21.7889 20.3056 21.8687 20.1816 21.9224 20.0457C21.976 19.9098 22.0023 19.7646 21.9998 19.6185V5.63123C22.0023 5.48513 21.976 5.33998 21.9224 5.20405C21.8687 5.06813 21.7889 4.9441 21.6873 4.83905C21.5857 4.734 21.4645 4.64999 21.3304 4.59182C21.1964 4.53364 21.0522 4.50244 20.9061 4.5Z"
        fill="#1F1F1F"
      />
      <path d="M5.75 9.5H6.99998V10.75H5.75V9.5Z" fill="#1F1F1F" />
      <path d="M9.5 9.5H10.75V10.75H9.5V9.5Z" fill="#1F1F1F" />
      <path d="M13.25 9.5H14.5V10.75H13.25V9.5Z" fill="#1F1F1F" />
      <path d="M17 9.5H18.25V10.75H17V9.5Z" fill="#1F1F1F" />
      <path d="M5.75 12.625H6.99998V13.875H5.75V12.625Z" fill="#1F1F1F" />
      <path d="M9.5 12.625H10.75V13.875H9.5V12.625Z" fill="#1F1F1F" />
      <path d="M13.25 12.625H14.5V13.875H13.25V12.625Z" fill="#1F1F1F" />
      <path d="M17 12.625H18.25V13.875H17V12.625Z" fill="#1F1F1F" />
      <path d="M5.75 15.75H6.99998V17H5.75V15.75Z" fill="#1F1F1F" />
      <path d="M9.5 15.75H10.75V17H9.5V15.75Z" fill="#1F1F1F" />
      <path d="M13.25 15.75H14.5V17H13.25V15.75Z" fill="#1F1F1F" />
      <path d="M17 15.75H18.25V17H17V15.75Z" fill="#1F1F1F" />
      <path
        d="M6.99999 6.99992C7.16575 6.99992 7.32472 6.93407 7.44192 6.81686C7.55913 6.69966 7.62498 6.54069 7.62498 6.37493V2.62499C7.62498 2.45923 7.55913 2.30026 7.44192 2.18306C7.32472 2.06585 7.16575 2 6.99999 2C6.83423 2 6.67526 2.06585 6.55806 2.18306C6.44085 2.30026 6.375 2.45923 6.375 2.62499V6.37493C6.375 6.54069 6.44085 6.69966 6.55806 6.81686C6.67526 6.93407 6.83423 6.99992 6.99999 6.99992Z"
        fill="#1F1F1F"
      />
      <path
        d="M17 6.99992C17.1657 6.99992 17.3247 6.93407 17.4419 6.81686C17.5591 6.69966 17.625 6.54069 17.625 6.37493V2.62499C17.625 2.45923 17.5591 2.30026 17.4419 2.18306C17.3247 2.06585 17.1657 2 17 2C16.8342 2 16.6753 2.06585 16.5581 2.18306C16.4408 2.30026 16.375 2.45923 16.375 2.62499V6.37493C16.375 6.54069 16.4408 6.69966 16.5581 6.81686C16.6753 6.93407 16.8342 6.99992 17 6.99992Z"
        fill="#1F1F1F"
      />
      <path d="M8.875 4.5H15.1249V5.74998H8.875V4.5Z" fill="#1F1F1F" />
    </svg>
  );
};

export default CalendarIcon;
